import { Button } from 'antd'
import PropTypes from 'prop-types'
import './ButtonCommon.scss'

export const ButtonCommon = ({
	onClick,
	type,
	loading,
	children,
	containerStyle,
	icon,
	iconColor,
	size,
	ghost,
	htmlType,
}) => {
	const handleClick = e => {
		e.stopPropagation()
		onClick && onClick()
	}

	return (
		<Button
			className="custom-btn"
			htmlType={htmlType}
			ghost={ghost}
			containerstyle={containerStyle}
			icon={icon}
			iconcolor={iconColor}
			size={size}
			type={type}
			loading={loading}
			onClick={handleClick}
		>
			{children}
		</Button>
	)
}

ButtonCommon.propTypes = {
	onClick: PropTypes.func,
	type: PropTypes.string,
	loading: PropTypes.bool,
	children: PropTypes.any,
	containerStyle: PropTypes.object,
	icon: PropTypes.node,
	iconColor: PropTypes.object,
	ghost: PropTypes.bool,
	htmlType: PropTypes.string,
}
